export default __webpack_public_path__ + "static/media/pexels-photo-998641.b1cd6ba6.jpeg";